import React from 'react';
import staticPath from 'util/misc/static-assets-path';

export default function Regions() {
    return (
        <div className="cms-regions">
            <div className="cms-regions--image">
                <img
                    src={staticPath('img/regions/im-pilotregion-bern.png')}
                    srcSet={`${ staticPath('img/regions/im-pilotregion-bern.png') } 1x, ${ staticPath(
                        'img/regions/im-pilotregion-bern@2x.png'
                    ) } 2x`}
                />
            </div>
            <div className="cms-regions--image">
                <img
                    src={staticPath('img/regions/im-pilotregion-zurich.png')}
                    srcSet={`${ staticPath('img/regions/im-pilotregion-zurich.png') } 1x, ${ staticPath(
                        'img/regions/im-pilotregion-zurich@2x.png'
                    ) } 2x`}
                />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/regions/index.js